import { render, staticRenderFns } from "./ShowGoods.vue?vue&type=template&id=0cd657e0&scoped=true"
import script from "./ShowGoods.vue?vue&type=script&lang=js"
export * from "./ShowGoods.vue?vue&type=script&lang=js"
import style0 from "./ShowGoods.vue?vue&type=style&index=0&id=0cd657e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd657e0",
  null
  
)

export default component.exports